import './spinner.css';
import logo from '../../assets/fala-480.png';

// Falashop loader: the logo "breathing" gently, and a thin track under it where an
// orange-to-green segment glides along, like the logo's little cart rolling.
// The same look is shown by index.html before the app has loaded (no blank page).
const Spinner: React.FC = () => {
    return (
        <div className="fala-loader" role="status" aria-live="polite">
            <img src={logo} alt="Falashop" className="fala-loader__logo" />
            <div className="fala-loader__track" aria-hidden="true">
                <span className="fala-loader__bar" />
            </div>
            <span className="fala-loader__text">Chargement…</span>
        </div>
    );
};

export default Spinner;
